export default __webpack_public_path__ + "static/media/Payment-OPtions.70e129da.jpg";